import { createSlice } from "@reduxjs/toolkit";
import { User } from "../models/User";

const UsersInitialState: {
	users: User[];
} = {
	users: [],
};

export const UsersReducer = createSlice({
	name: "__",
	initialState: UsersInitialState,
	reducers: {
		setUsers(state, { payload }) {
			state.users = payload;
		},
	},
});
